"use strict";
/*
 * Created on 27. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AsyncConsumer_1 = require("./AsyncConsumer");

var SparseMatrix_1 = require("./SparseMatrix"); //tslint:disable:max-classes-per-file

/**
 * Extension of async consumer that collects input into particular result.
 * @author Stepan Mik
 */


var SimpleAsyncCollector =
/*#__PURE__*/
function (_AsyncConsumer_1$Asyn) {
  _inherits(SimpleAsyncCollector, _AsyncConsumer_1$Asyn);

  function SimpleAsyncCollector() {
    _classCallCheck(this, SimpleAsyncCollector);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleAsyncCollector).apply(this, arguments));
  }

  _createClass(SimpleAsyncCollector, null, [{
    key: "list",
    value: function list() {
      return new (
      /*#__PURE__*/
      function (_SimpleAsyncCollector) {
        _inherits(_class, _SimpleAsyncCollector);

        function _class() {
          var _this;

          _classCallCheck(this, _class);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
          _this._result = immutable_1.List();
          return _this;
        }

        _createClass(_class, [{
          key: "consume",
          value: function consume(value) {
            this._result = this._result.push(value);
            return null;
          }
        }, {
          key: "finalize",
          value: function finalize() {
            var _this2 = this;

            return _get(_getPrototypeOf(_class.prototype), "finalize", this).call(this).then(function () {
              return _this2._result;
            });
          }
        }, {
          key: "result",
          get: function get() {
            return this._result;
          }
        }]);

        return _class;
      }(SimpleAsyncCollector))();
    }
  }, {
    key: "stringMatrix",
    value: function stringMatrix(row, col) {
      return new (
      /*#__PURE__*/
      function (_SimpleAsyncCollector2) {
        _inherits(_class2, _SimpleAsyncCollector2);

        function _class2() {
          var _this3;

          _classCallCheck(this, _class2);

          _this3 = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this));
          _this3._result = SparseMatrix_1.SparseMatrix.stringStringMatrix(null);
          return _this3;
        }

        _createClass(_class2, [{
          key: "consume",
          value: function consume(value) {
            this._result.set(row(value), col(value), value);

            return null;
          }
        }, {
          key: "finalize",
          value: function finalize() {
            var _this4 = this;

            return _get(_getPrototypeOf(_class2.prototype), "finalize", this).call(this).then(function () {
              return _this4._result;
            });
          }
        }, {
          key: "result",
          get: function get() {
            return this._result;
          }
        }]);

        return _class2;
      }(SimpleAsyncCollector))();
    }
  }]);

  return SimpleAsyncCollector;
}(AsyncConsumer_1.AsyncConsumer);

exports.SimpleAsyncCollector = SimpleAsyncCollector;